<sirius-icon [name]="resolvedIcon()"></sirius-icon>
<a [siriusLink]="resolvedLink()" class="sir-card__link" (linkSelect)="onClick()">
    @if (resolvedTitle(); as titleText) {
        <h3 class="sir-text-style-paragraph-m-default">{{ titleText }}</h3>
    } @else {
        <span class="sir-card__sr-only-label">{{ resolvedLink().title }}</span>
    }
</a>
